import { IEvidenceFile } from "@/types/typesAlerts";

/**
 * Which of a bulletin's photos each entity appears in.
 *
 * Photos are lettered where entities are hashed, so "photo C shows Suspect #2" cannot be misread
 * the way "#3 shows #2" can. The letter is the photo's place in the gallery, so the mark in the
 * entity row and the mark on the photo are the same mark.
 */

export interface EntityPhoto {
  /** Index into the same media list the gallery was given. */
  index: number;
  letter: string;
}

/** A, B, C … and past Z it doubles up: AA, AB. */
export const photoLetter = (index: number): string =>
  index < 26
    ? String.fromCharCode(65 + index)
    : String.fromCharCode(64 + Math.floor(index / 26)) +
      String.fromCharCode(65 + (index % 26));

/** Keyed by entity id, in gallery order. An entity no photo is linked to is absent. */
export const entityPhotos = (
  medias: IEvidenceFile[],
): Record<string, EntityPhoto[]> => {
  const byEntity: Record<string, EntityPhoto[]> = {};

  medias.forEach((media, index) => {
    media.entity_ids?.forEach((entityId) => {
      (byEntity[entityId] ??= []).push({ index, letter: photoLetter(index) });
    });
  });

  return byEntity;
};
